import { render } from "./HeroiconsOutlineVideoCamera.vue?vue&type=template&id=5d9f1e3e"
const script = {}

import exportComponent from "D:\\php-projects\\vemto apps\\tasky\\tasky_api_nova2_v9\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineVideoCamera.vue"]])

export default __exports__